import './StatisticGraphics.css';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import StatisticGraphicsModal from './component/StatisticGraphicsModal';
import { Button } from 'primereact/button';

function StatisticGraphics(props) {
  const { t } = useTranslation();
  const restoreElement = useRef();
  const [active, setActive] = useState(false);

  const handleClick = () => {
    setActive(prev => !prev);
  };

  return (
    <div id="StatisticGraphics" className="StatisticGraphics">
      <Button
        className="HorizontalButton"
        type="button"
        alt={t('statisticModal.heading')}
        title={t('statisticModal.heading')}
        onClick={handleClick}
        ref={restoreElement}
        icon="pi pi-chart-bar"
      >
      
      </Button>
      <StatisticGraphicsModal
        map={props.map}
        active={active}
        callback={setActive}
      />
    </div>
  );
}

export default StatisticGraphics;
